type DateOrString = Date | string | number

export const DAY = 86400000
export const YEAR = 31536000000
const today = new Date()

export const dateToYMDformat = (date = new Date()) => date.toLocaleDateString('en-CA') // 2023-01-22
const getDaysInMonth = (year: number, month: number) => new Date(year, month + 1, 0).getDate()

export const toTime = (dateOrString: DateOrString, locales: Intl.LocalesArgument = 'pl') => {
  if (!dateOrString) return '-'
  const date = getDateObject(dateOrString)
  return date.toLocaleTimeString(locales, { hour: '2-digit', minute: '2-digit' })
}

export const toShortDate = (dateOrString: DateOrString, locales: Intl.LocalesArgument) => {
  if (!dateOrString) return '-'
  const date = getDateObject(dateOrString)
  const theSameYear = today.getFullYear() === date.getFullYear()
  const options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'short'
  }
  if (!theSameYear) {
    options.year = 'numeric'
  }
  return date.toLocaleDateString(locales, options)
}

export const toLongDate = (dateOrString: DateOrString, locales: Intl.LocalesArgument, monthUsingNumbers = false) => {
  if (!dateOrString) return '-'
  const date = getDateObject(dateOrString)
  return date.toLocaleDateString(locales, { day: '2-digit', month: monthUsingNumbers ? '2-digit' : 'long', year: 'numeric' })
}

export const toDateTime = (dateOrString: DateOrString, locales: Intl.LocalesArgument) => {
  if (!dateOrString) return '-'
  const date = getDateObject(dateOrString)
  return date.toLocaleString(locales, { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })
}

const getDateObject = (dateOrString: DateOrString) => {
  return typeof dateOrString === 'object' ? dateOrString : new Date(dateOrString)
}

export const itIsToday = (dateOrString: DateOrString) => {
  if (!dateOrString) return '-'
  const date = getDateObject(dateOrString)
  return (
    today.getDate() === date.getDate()
    && today.getMonth() === date.getMonth()
    && today.getFullYear() === date.getFullYear()
  )
}

const getDate = (dateOrString: DateOrString) => {
  const date = getDateObject(dateOrString)
  return {
    day: date.getDate(),
    month: date.getMonth(),
    year: date.getFullYear(),
  }
}

export const getEndDate = ({ m = 0, d = 0 }, startDate?: DateOrString, returnDateObject = false) => {
  if (m < 0) return undefined

  const start = getDate(startDate || new Date())
  const daysInMonth = getDaysInMonth(start.year, start.month)

  const days = start.day + d
  const months = start.month + m + (days / daysInMonth | 0)

  const end = {
    day: days % daysInMonth,
    month: months % 12,
    year: start.year + (months / 12 | 0),
  }

  const returnDate = new Date(end.year, end.month, end.day)
  return returnDateObject
    ? returnDate
    : dateToYMDformat(returnDate)
}

export const getRangeFromDates = (endDate = new Date(), startDate = new Date()) => {
  const start = getDate(startDate)
  const end = getDate(endDate)

  const monthDiff = (12 * (end.year - start.year)) + end.month - start.month
  const daysDiff = end.day - start.day

  if (daysDiff < 0) {
    const daysInLastMonth = !end.month ? 31 : getDaysInMonth(end.year, end.month - 1)
    const d = daysInLastMonth + daysDiff

    return { m: monthDiff - 1, d }

  } else return { m: monthDiff, d: daysDiff }
}